import type { ErrorResponse } from './codegen'

export function upsertItems<T extends { readonly id: string }>(
  items: T[],
  sortFn?: (a: T, b: T) => number,
): (oldData?: T[]) => T[]
export function upsertItems<T extends object>(
  items: T[],
  sortFn: ((a: T, b: T) => number) | undefined,
  selectIdFn: (item: T) => string,
): (oldData?: T[]) => T[]

export function upsertItems<T extends { readonly id: string }>(
  items: T[],
  sortFn?: ((a: T, b: T) => number) | undefined,
  selectIdFn?: (item: T) => string,
) {
  const getId = selectIdFn || ((item) => item.id)

  return (oldData?: T[]) => {
    const updatedOldItems = (oldData || []).map(
      (oldItem) =>
        items.find((item) => getId(item) === getId(oldItem)) ?? oldItem,
    )

    const oldIds = (oldData || []).map((item) => getId(item))
    const newItems = items.filter((item) => !oldIds.includes(getId(item)))
    const updatedItems = [...updatedOldItems, ...newItems]

    return sortFn ? updatedItems.sort(sortFn) : updatedItems
  }
}

export const removeItemWithId =
  <T extends { readonly id?: string }>(
    id: string,
    selectIdFn?: (item: T) => string,
  ) =>
  (oldData?: T[]) => {
    if (!oldData) {
      return
    }

    const getId = selectIdFn || ((item) => item.id)

    return oldData.filter((item) => {
      const itemId = getId(item)

      return itemId !== id
    })
  }

export function removeItems<T extends { readonly id: string }>(
  items: T[],
): (oldData?: T[]) => T[]
export function removeItems<T extends object>(
  items: T[],
  selectIdFn: (item: T) => string,
): (oldData?: T[]) => T[]

export function removeItems<T extends { readonly id: string }>(
  items: T[],
  selectIdFn?: (item: T) => string,
) {
  const getId = selectIdFn || ((item) => item.id)

  return (oldData?: T[]) => {
    if (!oldData) {
      return
    }

    const ids = items.map(getId)

    return oldData.filter((item) => !ids.includes(getId(item)))
  }
}

export const getErrorMessage = (
  error: ErrorResponse,
  defaultMessage = 'Unknown error occurred',
) => {
  // oxlint-disable-next-line no-console
  console.error(error)

  return error.message || defaultMessage
}
